import "./infobadge.css";

export default function InfoGlassBadge({ children, variant = "gold", className = "" }) {
  return (
    <div className={"info-badge info-badge--" + variant + (className ? " " + className : "")} role="note">
      <span className="info-badge-icon" aria-hidden="true">
        <img src="/design/icons-lg/info-gold.svg" alt="" width={24} height={24} />
      </span>
      <span className="info-badge-text">{children}</span>
    </div>
  );
}
